// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"113":"b4f16894","893":"54bb6f06"}[chunkId] + ".chunk.css";
};